// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `tbody {
  border-bottom: 1px solid var(--app-table-divider);
}

.clickable-row {
  cursor: pointer;
}

.clickable-row:hover {
  background-color: var(--app-ink-alpha-40);
}
td {
  margin-left: 5px;
  margin-right: 5px;
}
.table-responsive {
  white-space: nowrap;
}
.table-scroll {
  display: block;
  position: relative;
  overflow: auto;
}

.input-group{
  border: 0.5px solid var(--app-table-search);
  border-radius: 5px;
  min-width: 160px;
  max-width: 230px;
}

.input-group .btn {
  display: flex;
  align-items: center;
  background-color: var(--app-white);
  padding-inline: 8px;
  padding-top: 0;
  padding-bottom: 0;
  border: none;
}

.input-group .form-control {
  color: var(--app-legacy-divider);
  background-color: var(--app-white);
  border: none;
}

.table-search-icon { color: var(--app-table-search); font-size: var(--app-font-size-icon-large); }
.table-paginator { flex-shrink: 0; }
.table-scroll { height: auto; }
.table-action-icon { text-decoration: none; color: var(--app-black); }
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/table/table.component.css"],"names":[],"mappings":"AAAA;EACE,iDAAiD;AACnD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,YAAY;AACd;;AAEA,qBAAqB,8BAA8B,EAAE,0CAA0C,EAAE;AACjG,mBAAmB,cAAc,EAAE;AACnC,gBAAgB,YAAY,EAAE;AAC9B,qBAAqB,qBAAqB,EAAE,uBAAuB,EAAE","sourcesContent":["tbody {\n  border-bottom: 1px solid var(--app-table-divider);\n}\n\n.clickable-row {\n  cursor: pointer;\n}\n\n.clickable-row:hover {\n  background-color: var(--app-ink-alpha-40);\n}\ntd {\n  margin-left: 5px;\n  margin-right: 5px;\n}\n.table-responsive {\n  white-space: nowrap;\n}\n.table-scroll {\n  display: block;\n  position: relative;\n  overflow: auto;\n}\n\n.input-group{\n  border: 0.5px solid var(--app-table-search);\n  border-radius: 5px;\n  min-width: 160px;\n  max-width: 230px;\n}\n\n.input-group .btn {\n  display: flex;\n  align-items: center;\n  background-color: var(--app-white);\n  padding-inline: 8px;\n  padding-top: 0;\n  padding-bottom: 0;\n  border: none;\n}\n\n.input-group .form-control {\n  color: var(--app-legacy-divider);\n  background-color: var(--app-white);\n  border: none;\n}\n\n.table-search-icon { color: var(--app-table-search); font-size: var(--app-font-size-icon-large); }\n.table-paginator { flex-shrink: 0; }\n.table-scroll { height: auto; }\n.table-action-icon { text-decoration: none; color: var(--app-black); }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
